/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */

export enum UnitStatReportUpdateTypeEnum {
  NOT_SET = 'NotSet',
  ADD = 'Add',
  CHANGE = 'Change',
  DELETE = 'Delete',
  PREV_REPORTED = 'PrevReported',
  REVISED = 'Revised',
  INVALID = 'Invalid',
  MISSING_ENUM = 'MissingEnum',
}
